//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';

export interface ParamsType {
    id: number;
}

const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api/event/{id} -> get -> ${code}`);
    };
};

export const Response200IO = t.interface({
    result: t.union([
        t.null,
        t.undefined,
        t.interface({
            active: t.boolean,
            antePost: t.boolean,
            autoTakeDown: t.union([t.null, t.undefined, t.boolean]),
            competition: t.number,
            display: t.boolean,
            eventType: t.union([t.null, t.undefined, t.string]),
            feedData: t.union([t.null, t.undefined, t.record(t.string, t.string)]),
            feedSettings: t.union([
                t.null,
                t.undefined,
                t.interface({
                    eachWay: t.union([t.null, t.undefined, t.boolean]),
                    prices: t.union([t.null, t.undefined, t.boolean]),
                    results: t.union([t.null, t.undefined, t.boolean]),
                    updates: t.union([t.null, t.undefined, t.boolean]),
                }),
            ]),
            grades: t.union([
                t.null,
                t.undefined,
                t.interface({
                    inPlay: t.union([
                        t.null,
                        t.undefined,
                        t.interface({
                            id: t.number,
                            name: t.string,
                        }),
                    ]),
                    prematch: t.union([
                        t.null,
                        t.undefined,
                        t.interface({
                            id: t.number,
                            name: t.string,
                        }),
                    ]),
                    show: t.union([
                        t.null,
                        t.undefined,
                        t.interface({
                            id: t.number,
                            name: t.string,
                        }),
                    ]),
                }),
            ]),
            id: t.number,
            idv2: t.string,
            incidents: t.union([
                t.null,
                t.undefined,
                t.array(
                    t.interface({
                        addedManually: t.union([t.null, t.undefined, t.boolean]),
                        bettable: t.union([
                            t.null,
                            t.undefined,
                            t.interface({
                                type: t.union([t.null, t.undefined, t.string]),
                            }),
                        ]),
                        deleted: t.union([t.null, t.undefined, t.boolean]),
                        editedManually: t.union([t.null, t.undefined, t.boolean]),
                        feedUpdatable: t.union([t.null, t.undefined, t.boolean]),
                        id: t.union([t.null, t.undefined, t.string]),
                        period: t.union([t.null, t.undefined, t.string]),
                        player: t.union([t.null, t.undefined, t.string]),
                        team: t.union([t.null, t.undefined, t.string]),
                        time: t.union([
                            t.null,
                            t.undefined,
                            t.interface({
                                minutes: t.union([t.null, t.undefined, t.number]),
                                seconds: t.union([t.null, t.undefined, t.number]),
                            }),
                        ]),
                    })
                ),
            ]),
            name: t.string,
            participants: t.record(
                t.string,
                t.interface({
                    id: t.number,
                    idv2: t.union([t.null, t.undefined, t.string]),
                    metadata: t.union([t.null, t.undefined, t.record(t.string, t.string)]),
                    name: t.union([t.null, t.undefined, t.string]),
                    role: t.union([t.null, t.undefined, t.string]),
                })
            ),
            platformObject: t.union([
                t.null,
                t.undefined,
                t.interface({
                    feedProviderName: t.union([t.null, t.undefined, t.string]),
                    id: t.union([t.null, t.undefined, t.string]),
                    name: t.union([t.null, t.undefined, t.string]),
                }),
            ]),
            rawGameState: t.union([t.null, t.undefined, t.string]),
            revision: t.number,
            sport: t.string,
            state: t.string,
            statistics: t.record(t.string, t.record(t.string, t.string)),
            stream: t.union([
                t.null,
                t.undefined,
                t.array(
                    t.interface({
                        eventId: t.number,
                        eventName: t.string,
                        geoRuleCountries: t.string,
                        geoRuleType: t.union([t.literal('DENY'), t.literal('ALLOW')]),
                        id: t.number,
                        live: t.boolean,
                        provider: t.string,
                        universe: t.string,
                    })
                ),
            ]),
            tags: t.record(t.string, t.string),
            template: t.string,
            timeSettings: t.interface({
                offAtStartTime: t.union([t.null, t.undefined, t.boolean]),
                startTime: t.string,
                started: t.boolean,
                timeZone: t.string,
                timeline: t.union([t.null, t.undefined, t.string]),
                tradedInPlay: t.boolean,
            }),
            updated: t.interface({
                updatedAt: t.string,
            }),
            updatedInMs: t.number,
            uuid: t.union([t.null, t.undefined, t.string]),
        }),
    ]),
});
export type Response200Type = {
    result?:
        | null
        | undefined
        | {
              active: boolean;
              antePost: boolean;
              autoTakeDown?: null | undefined | boolean;
              competition: number;
              display: boolean;
              eventType?: null | undefined | string;
              feedData?: null | undefined | Record<string, string>;
              feedSettings?:
                  | null
                  | undefined
                  | {
                        eachWay?: null | undefined | boolean;
                        prices?: null | undefined | boolean;
                        results?: null | undefined | boolean;
                        updates?: null | undefined | boolean;
                    };
              grades?:
                  | null
                  | undefined
                  | {
                        inPlay?:
                            | null
                            | undefined
                            | {
                                  id: number;
                                  name: string;
                              };
                        prematch?:
                            | null
                            | undefined
                            | {
                                  id: number;
                                  name: string;
                              };
                        show?:
                            | null
                            | undefined
                            | {
                                  id: number;
                                  name: string;
                              };
                    };
              id: number;
              idv2: string;
              incidents?:
                  | null
                  | undefined
                  | Array<{
                        addedManually?: null | undefined | boolean;
                        bettable?:
                            | null
                            | undefined
                            | {
                                  type?: null | undefined | string;
                              };
                        deleted?: null | undefined | boolean;
                        editedManually?: null | undefined | boolean;
                        feedUpdatable?: null | undefined | boolean;
                        id?: null | undefined | string;
                        period?: null | undefined | string;
                        player?: null | undefined | string;
                        team?: null | undefined | string;
                        time?:
                            | null
                            | undefined
                            | {
                                  minutes?: null | undefined | number;
                                  seconds?: null | undefined | number;
                              };
                    }>;
              name: string;
              participants: Record<
                  string,
                  {
                      id: number;
                      idv2?: null | undefined | string;
                      metadata?: null | undefined | Record<string, string>;
                      name?: null | undefined | string;
                      role?: null | undefined | string;
                  }
              >;
              platformObject?:
                  | null
                  | undefined
                  | {
                        feedProviderName?: null | undefined | string;
                        id?: null | undefined | string;
                        name?: null | undefined | string;
                    };
              rawGameState?: null | undefined | string;
              revision: number;
              sport: string;
              state: string;
              statistics: Record<string, Record<string, string>>;
              stream?:
                  | null
                  | undefined
                  | Array<{
                        eventId: number;
                        eventName: string;
                        geoRuleCountries: string;
                        geoRuleType: 'DENY' | 'ALLOW';
                        id: number;
                        live: boolean;
                        provider: string;
                        universe: string;
                    }>;
              tags: Record<string, string>;
              template: string;
              timeSettings: {
                  offAtStartTime?: null | undefined | boolean;
                  startTime: string;
                  started: boolean;
                  timeZone: string;
                  timeline?: null | undefined | string;
                  tradedInPlay: boolean;
              };
              updated: {
                  updatedAt: string;
              };
              updatedInMs: number;
              uuid?: null | undefined | string;
          };
};
export const decodeResponse200 = createGuard(200, Response200IO);

type ExtraHeadersType = Record<string, string>;

/**
 * @deprecated - Please use this method "openapiSocketGetEventRequest"
 */
export const openapi_socket_get_event = async (
    api_url: string,
    api_timeout: number,
    backendToken: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<FetchGeneralRawResponseType> => {
    const query = '';
    const url = `${api_url}/api/event/${params.id}${query}`;

    const method = 'GET';
    const paramsFetch = {
        url,
        body: undefined,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};

export type OpenapiSocketGetEventParamsType = ParamsType;

export type OpenapiSocketGetEventResponseType = {
    status: 200;
    body: Response200Type;
};

export type OpenapiSocketGetEventResponse200Type = Response200Type;

export const openapiSocketGetEventRequest = async (
    api_url: string,
    api_timeout: number,
    backendToken: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<OpenapiSocketGetEventResponseType> => {
    const response = await openapi_socket_get_event(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }

    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    throw new Error(`openapiSocketGetEventRequest - unhandled response ${response.status}`);
};
